export enum WatchListColumnsEnum {
	ticker = 'ticker',
	company = 'company',
	price = 'price',
	watchListChangeColumnDollar = 'watchListChangeColumnDollar',
	watchListChangeColumnPercent = 'watchListChangeColumnPercent',
}
